import { SnackbarProvider } from '@/design-system';
import { useContext } from 'react';
import AutenticatedLayout from './AuthenticatedLayout';
import NonAutenticatedLayout from './NonAuthenticatedLayout';
import { PeachjarLoader } from './components';
import AuthenticationContext from './context/AuthenticationContext';
import { useHubspotCookieBannerDialogA11y, useIsEmbed, useServiceWorkerUpdate } from './hooks';
import { EmbedRoutes } from './routes/EmbedRoutes';

function App() {
  useHubspotCookieBannerDialogA11y();
  useServiceWorkerUpdate();

  const { isAuthenticated, isLoading } = useContext(AuthenticationContext);

  if (isLoading) return <PeachjarLoader />;

  const isEmbedded = useIsEmbed();

  if (isEmbedded) {
    return <EmbedRoutes />;
  }

  return (
    <>
      {isAuthenticated ? <AutenticatedLayout /> : <NonAutenticatedLayout />}
      <SnackbarProvider />
    </>
  );
}

export default App;
